import React, { useState } from 'react';
import { Modal, Button, Form, Container, Row, Col } from 'react-bootstrap';
import Usuario from '../../../model/Usuario/Usuario';
import { Perfil } from '../../../model/Usuario/Perfil';

interface EditarPerfilModalProps {
    show: boolean;
    handleClose: () => void;
    usuario: Usuario;
    perfisDisponiveis: Perfil[];
    onSave: (usuario: Usuario) => void;
}

const EditarPerfilModal: React.FC<EditarPerfilModalProps> = ({ show, handleClose, usuario, perfisDisponiveis, onSave }) => {
    const [perfilSelecionado, setPerfilSelecionado] = useState<Perfil | null>(usuario.perfil || null);
    const [filtroNome, setFiltroNome] = useState('');

    const perfisFiltrados = perfisDisponiveis.filter(perfil =>
        perfil.nome!.toLowerCase().includes(filtroNome.toLowerCase())
    );

    const handlePerfilClick = (perfilNome: string) => {
        const perfil = perfisDisponiveis.find(p => p.nome === perfilNome) || null;
        setPerfilSelecionado(perfil);
    };

    const handleSave = () => {
        if (perfilSelecionado) {
            const updatedUsuario = { ...usuario, perfil: perfilSelecionado };
            onSave(updatedUsuario);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Editar Perfil de {usuario.username}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container className="shadow-lg p-3 mb-3 bg-body rounded rounded-4">
                    <Row>
                        <Col>
                            <Form.Group controlId="filtroNome">
                                <Form.Label>Filtrar Perfil por Nome</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Digite o nome do perfil"
                                    value={filtroNome}
                                    onChange={(e) => setFiltroNome(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col>
                            <div style={{ padding: '3px', borderRadius: '8px' }}>
                                {perfisFiltrados.length > 0 ? (
                                    <ul className="list-group">
                                        <h4>Perfis</h4>
                                        {perfisFiltrados.map(perfil => (
                                            <li
                                                key={perfil.nome}
                                                className={`list-group-item ${perfilSelecionado?.nome === perfil.nome ? 'active' : ''}`}
                                                onClick={() => handlePerfilClick(perfil.nome!)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <>{perfil.nome}</>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p>Nenhum perfil encontrado</p>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>


                {perfilSelecionado &&(
                    <>
                        <Container className="shadow p-3 mb-3 bg-body rounded rounded-4">
                            {perfilSelecionado && (
                                <Row className="mt-4">
                                    <Col>{perfilSelecionado.permissoes.length > 0 ?
                                        <>
                                            <h5>Permissões de {' ' + perfilSelecionado.nome}</h5>
                                            <ul>
                                                {perfilSelecionado.permissoes.map(permissao => (
                                                    <li key={permissao.nome}>{permissao.nome} - {permissao.descricao}</li>
                                                ))}
                                            </ul>
                                        </>
                                        : <>
                                            Não há Permissões configuradas para este Perfil.
                                        </>}
                                    </Col>
                                </Row>
                            )}
                        </Container>
                    </>
                    )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Cancelar</Button>
                <Button variant="primary" onClick={handleSave}>Salvar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditarPerfilModal;
